import React, { useEffect, useRef } from "react";
import styles from "./ContactInfo.module.css";
import { Mail, Phone, Clock, MapPin } from "lucide-react";
import { CONTACT_INFO_CONTENT } from "../../Constants";

const ContactInfo = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const elements =
      sectionRef.current.querySelectorAll("[data-animate]");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // Icons remain inside component (best practice)
  const icons = [Mail, Phone, Clock, MapPin];

  return (
    <section ref={sectionRef} className={styles.section}>
      <div className={styles.container}>
        {CONTACT_INFO_CONTENT.map((item, index) => {
          const Icon = icons[index];

          return (
            <div
              key={index}
              data-animate
              className={`${styles.card} ${styles.animate} ${
                styles.fadeUp
              } ${styles[`delay${index}`] || ""}`}
            >
              <div className={styles.iconBox}>
                <Icon size={26} />
              </div>

              <h3>{item.title}</h3>

              {item.lines.map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ContactInfo;